//Establecemos los datos de la api
const conexiones = {
  Local: "http://localhost:50037/",
  Desarrollo_AmericaLeon: "http://srvapi:6/",
  Desarrollo_CitlalliJara: "http://srvapi:419/",
  Desarrollo_EduardoQuiroz: "http://srvapi:69/",
  Desarrollo_FranciscoOrduno: "http://srvapi:30/",
  Desarrollo_FabianCano: "http://srvapi:14/",
  Desarrollo_ManuelGonzalez: "http://srvapi:8888/",
  Desarrollo_FlavioGonzalez: "http://srvapi:600/",
  Desarrollo_CesarGuerrero: "http://srvapi:1515/",
  Desarrollo_ManuelEsquivel: "http://srvapi:3333/",
  Desarrollo_FlorRuiz: "http://srvapi:8532/",
  Desarrollo_CristinaGallegos: "http://srvapi:3/",
  Desarrollo: "http://srvapi:8020/",
  ProduccionForsetiSala1: "http://10.0.55.110:61/",
  ProduccionForsetiPruebas: "http://172.16.21.148:61/",
  Produccion: "https://api.poderjudicialags.gob.mx/"
};

export default conexiones;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/conexion.js
// module id = null
// module chunks = 